const contentEN = {
    language: 'en',
    content: {
        personalDetailsStep: {
            caption: "Let's complete your profile ({stepNumber} of {totalStepsCount})",
            title: 'Personal details'
        },
        userSurname: {
            ariaLabel: 'Family name',
            fieldName: 'Family name',
            hint: '',
            label: 'Family name',
            errors: {
                empty: 'Please enter your family name',
                maxLength: 'Family name must be 50 characters or less',
                summary: 'You must provide family name'
            }
        },
        userTitle: {
            ariaLabel: 'Title',
            fieldName: 'Title',
            hint: '',
            label: 'Title',
            errors: {
                empty: 'Please select a title'
            }
        },
        userFirstname: {
            ariaLabel: 'First name',
            fieldName: 'First name',
            hint: '',
            label: 'First name',
            errors: {
                empty: 'Please enter your first name',
                maxLength: 'First name must be 50 characters or less',
                summary: 'You must provide first name'
            }
        },
        summaryError: {
            errors: {
                validationError: 'There’s a problem with one of your answers or you missed a required question'
            }
        },
        profile: {
            errorModal: {
                userExists: "It is not possible to set up a new user account using this email address.  Please <a href=\\'https://testcms.gmc-uk.org/contact-us\\'>contact us</a>.",
                unavailable: "Our system is currently unavailable. Please try again later or <a href=\\'https://testcms.gmc-uk.org/contact-us\\'>contact us</a>.",
                header: "Sorry, we can't complete your sign up right now",
                badRequest: "Something has gone wrong.  Please <a href=\\'https://testcms.gmc-uk.org/contact-us\\'>contact us</a>."
            }
        },
        title: {
            answers: {
                miss: {
                    ariaLabel: 'Miss title option label',
                    id: 'MISS',
                    label: 'Miss',
                    order: '3',
                    value: 'MISS'
                },
                dr: {
                    label: 'Dr',
                    id: 'DR',
                    ariaLabel: 'Dr title option label',
                    order: '6',
                    value: 'DR'
                },
                professor: {
                    label: 'Professor',
                    ariaLabel: 'Professor title option label',
                    id: 'PROFESSOR',
                    order: '7',
                    value: 'PROFESSOR'
                },
                mr: {
                    ariaLabel: 'Mr title option label',
                    id: 'MR',
                    label: 'Mr',
                    order: '1',
                    value: 'MR'
                },
                mrs: {
                    ariaLabel: 'Mrs title option label',
                    id: 'MRS',
                    label: 'Mrs',
                    order: '2',
                    value: 'MRS'
                },
                ms: {
                    ariaLabel: 'Ms title option label',
                    id: 'MS',
                    label: 'Ms',
                    order: '4',
                    value: 'MS'
                },
                mx: {
                    ariaLabel: 'Mx title option label',
                    id: 'MX',
                    label: 'Mx',
                    order: '5',
                    value: 'MX'
                }
            }
        },
        defaultErrors: {
            alphaNumOnly: 'No special characters',
            dobFormat: 'Please correct your date of birth',
            dobMandatory: 'Please enter your date of birth',
            mandatory: 'This is a required field',
            maxLength: 'Exceeded max length',
            minLength: 'Invalid length',
            numbersOnly: 'This is a number only field',
            sameAsField: "Field doesn't match",
            textOnly: 'This is a text only field',
            email: 'Invalid email format'
        },
        global: {
            stepCaption: "Let's complete your profile ({stepNumber} of {totalStepsCount})",
            buttons: {
                saveAndExitButton: {
                    label: 'Save and exit'
                },
                nextButton: {
                    label: 'Next'
                },
                finishButton: {
                    label: 'Finish'
                },
                backButton: {
                    label: 'Back'
                }
            }
        },
        footer: {
            registrationInfo: 'The GMC is a registered charity in England and Wales (1089278) and Scotland (SC037750)',
            copyrightInfo: '&copy; {currentYear} General Medical Council. All rights reserved.'
        },
        notFoundPage: {
            title: 'Sorry, we can&rsquo;t find the page you&rsquo;re looking for',
            gmcConnect: {
                introduction: "The page may have been moved, updated or deleted.&nbsp;<a href=\\'/gmcconnect\\'>Home page</a>"
            }
        },
        homePage: {
            salutation: {
                passedPARA: "<h2>We've received your national assessment results, you can now apply to join the register.</h2>\\r\\n<p>You'll need to complete your application below before we can assess whether you can join the medical register.</p>",
                applicationCardDescription: 'Physician Associate registration with work experience (123456789)',
                PARA: {
                    failed: '<h2>We have your results and unfortunately you have not passed the Physician Associate Registration Assessment.</h2>\\r\\n<p>You can view information on text steps by clicking the link below. If you have any questions or need help on what to do next please contact us.</p>'
                }
            }
        }
    }
};
export default contentEN;
